import { Component, OnInit } from '@angular/core';
import { DataserviceService } from '../dataservice.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-marketing-leads',
  templateUrl: './marketing-leads.component.html',
  styleUrl: './marketing-leads.component.css',
})
export class MarketingLeadsComponent implements OnInit {
  isLoading: boolean = false;
  loadingMessage: string = '';
  leads: any;
  currentUser: any;
  isModalVisible: boolean = false;
  isHistoryModalVisible: boolean = false;
  selected: any;
  historyOrder: any;
  stateForm: FormGroup;
  addForm: FormGroup;
  users: any;
  historyTable: any;
  addModal: boolean = false;

  statuses = [
    { name: 'Called', state: 'called' },
    { name: 'No Answer', state: 'no answer' },
    { name: 'Interested', state: 'interested' },
    { name: 'Call Back', state: 'callback' },
    { name: 'DND', state: 'dnd' },
    { name: 'Completed', state: 'completed' },
  ];

  constructor(private data: DataserviceService, private message: NzMessageService, private fb: FormBuilder) {
    this.currentUser = JSON.parse(localStorage.getItem('user')!);

    this.addForm = this.fb.group({
      first: ['', Validators.required],
      last: ['', Validators.required],
      email: ['', Validators.required, Validators.email],
      phone: ['', Validators.required],
      status: ['', Validators.required],
    })

    this.stateForm = this.fb.group({
      state: ['', Validators.required]
    })
  }

  ngOnInit() {
    this.leads = [];
    this.historyOrder = { history: [] };
    this.getData();
    this.getUsers();
  }

  loadingHelper(onOff: boolean, message?: any) {
    if (message) {
      this.loadingMessage = message;
    } else {
      this.loadingMessage = 'Loading...';
    }
    this.isLoading = onOff;
  }

  getData() {
    this.loadingHelper(true, 'Getting leads...');
    this.data.getData('marketing-leads').subscribe(
      (res) => {
        if (res.result === 'success') {
          this.leads = Array.isArray(res.data) ? res.data : [];
          this.loadingHelper(false);
        } else {
          this.leads = [];
          this.loadingHelper(false);
          this.message.error('Failed to load leads.');
        }
      },
      (e) => {
        console.error('Error in loading leads:', e);
        this.leads = [];
        this.message.error('Failed to load leads.');
      }
    );
  }

  getUsers() {
    this.loadingHelper(true, 'Loading data...');
    this.data.getData('users/web').subscribe((users: any) => {
      this.users = users
    })
  }

  getUserName(userId: string): string {
    if (!userId) {
      return 'Customer';
    }
    const user = this.users?.find((u: any) => u.id === userId);
    return user ? `${user.first_name} ${user.last_name}` : 'Unknown';
  }

  showResolveModal(order: any) {
    this.selected = order;
    this.isModalVisible = true;
  }

  showAddModal(){
    this.addModal = true;
  }

  seeHistory(order: any) {
    this.historyOrder = order;

    if (!Array.isArray(this.historyOrder.history)) {
      this.historyOrder.history = this.historyOrder.history ? [this.historyOrder.history] : [];
    }

    if (this.historyOrder.history.length === 0) {
      this.message.info('No history available for this lead.');
      return;
    }

    this.isHistoryModalVisible = true;
  }

  closeHistoryModal() {
    this.historyOrder = {};
    this.isHistoryModalVisible = false;
  }

  handleCancel() {
    this.selected = {};
    this.isModalVisible = false;
  }

  handleOk() {
    if (this.stateForm.invalid) {
      this.message.error('Please select a valid state.');
      return;
    }

    this.loadingHelper(true, 'Updating lead...');

    const obj = {
      id: this.selected.id,
      status: this.stateForm.value.state,
      user: this.currentUser.id,
    };

    this.data.postData(obj, 'marketing-leads/update-lead').subscribe(
      (res) => {
        if (res.result === 'success') {
          this.message.success('Lead successfully updated!');
          this.handleCancel();
          this.getData();
        } else {
          this.message.error('Failed to update lead.');
        }
        this.loadingHelper(false);
      },
      (e) => {
        console.error('Error in updating lead:', e);
        this.message.error('Failed to update lead.');
        this.loadingHelper(false);
      },
    );
  }

  cancelAdd(){
    this.addForm.reset();
    this.addModal = false;
  }

  confirmAdd(){
    if(this.addForm.invalid){
      this.message.error('Please fill out all the fields.')
    }

    this.loadingHelper(true, 'Creating lead...')

    const obj = {
      userId: this.currentUser.id,
      firstName: this.addForm.value.first,
      lastName: this.addForm.value.last,
      phone: this.addForm.value.phone,
      email: this.addForm.value.email,
      status: this.addForm.value.status
    }

    this.data.postData(obj, 'marketing-leads/manual-create').subscribe(
      (res)=>{
        if(res.result === 'success'){
          this.message.success('Lead created successfully!')
          this.cancelAdd();
          this.getData();
        }
        this.loadingHelper(false)
      },
      (e)=>{
        console.error('Error in confirmAdd: ', e);
        this.message.error('Failed to create lead.');
        this.loadingHelper(false);
      }
    )
  }

}
